import { BLOB_ASSETS_BASE_URL } from '../constants'
import type { InvestmentPackage } from '../types/coreApi-types'

export interface InvestmentPackageOption {
  id: InvestmentPackage
  title: string
  tagline: string
  /** Full copy for explainer cards and detail views */
  description: string
  /** Short line for dropdown menu (keeps selector compact) */
  dropdownSummary: string
  riskLabel: string
  profitPotential: string
  cardVariant: 'warm' | 'dark'
  /** Full URL to the agreement PDF (Azure Blob or other) */
  pdfUrl: string
}

export const INVESTMENT_PACKAGE_OPTIONS: InvestmentPackageOption[] = [
  {
    id: 'Edge',
    title: 'Penning Edge',
    tagline: 'Time the Market',
    description:
      'A dynamic allocation typically consisting of a combination of BTC and ETH spot holdings paired with our proprietary market cycle timing system, the Phoenix Protocol.',
    dropdownSummary: 'Time the Market · Spot BTC/ETH, Phoenix Protocol',
    riskLabel: 'Low to medium risk',
    profitPotential: 'Medium profit potential',
    cardVariant: 'warm',
    pdfUrl: `${BLOB_ASSETS_BASE_URL}/penning-edge-agreement.pdf`,
  },
  {
    id: 'Trade',
    title: 'Penning Trade',
    tagline: 'Markets Solved With Math',
    description:
      'A dynamically rebalanced portfolio of proprietary algorithmic trading strategies trading mainly in BTC and/or ETH futures.',
    dropdownSummary: 'Markets Solved With Math · BTC/ETH futures strategies',
    riskLabel: 'Medium to high risk',
    profitPotential: 'High profit potential',
    cardVariant: 'dark',
    pdfUrl: `${BLOB_ASSETS_BASE_URL}/penning-trade-agreement.pdf`,
  },
]

export const INVESTMENT_PACKAGE_LABELS: Record<InvestmentPackage, string> = {
  Edge: 'Penning Edge',
  Trade: 'Penning Trade',
}

export const INVESTMENT_PACKAGE_PDF_PATHS: Record<InvestmentPackage, string> = {
  Edge: `${BLOB_ASSETS_BASE_URL}/penning-edge-agreement.pdf`,
  Trade: `${BLOB_ASSETS_BASE_URL}/penning-trade-agreement.pdf`,
}
